import React, { useState, useEffect } from "react";
import "./Trophie.css";





const Trophie = () => {
  const littleDown = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/LittledownTrophy.jpeg"
  const trophyPic1 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/New-Gladiators-Cup2025.jpg";
  const trophyPic2 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy2.jpg";
  const trophyPic3 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy3.jpg";
  const trophyPic4 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy4.jpg";
  const trophyPic5 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy5.jpg";
  const trophyPic6 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy6.jpg";
  const trophyPic7 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy7.jpg";
  const trophyPic8 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy8.jpg";
  const trophyPic9 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy9.jpg";
  const trophyPic10 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy10.jpg";
  const trophyPic11 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/tr01.jpg";
  // import trophyPic12 from "../../../assets/pics/tr1.jpg";
  // import trophyPic13 from "../../../assets/pics/tr2.jpg";
  const trophyPic14 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/tr3.jpg";
  const trophyPic15 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/tr4.jpg";
  const trophyPic16 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/tr5.jpg";
  const trophyPic17 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/tr6.jpg";
  const trophyPic18 = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/tr7.jpg";
  // import trophyPic19 from "../../../assets/pics/trophy10.jpg";

  const trophies = [
    { id: 1, image: littleDown, title: "LittleDown League Winners 2025" },
    { id: 2, image: trophyPic1, title: "CUPA UNIRII 2025" },
    { id: 3, image: trophyPic2, title: "Respect League" },
    { id: 4, image: trophyPic3, title: "CUPA 5Plus1 UK" },
    { id: 5, image: trophyPic4, title: "PLAYFOOTBALL League" },
    { id: 6, image: trophyPic5, title: "CUPA 5Plus1 UK" },
    { id: 7, image: trophyPic6, title: "IFL Champions 2024" },
    { id: 8, image: trophyPic7, title: "IFL Champions 2024" },
    { id: 9, image: trophyPic8, title: "IFL Champions 2024" },
    { id: 10, image: trophyPic9, title: "IFL Champions 2024" },
    { id: 11, image: trophyPic10, title: "Super League 2025" },
    { id: 12, image: trophyPic11, title: "Super League 2025" },
    // { id: 12, image: trophyPic12, title: "IFL Champions 2024" },
    // { id: 13, image: trophyPic13, title: "IFL Champions 2024" },
    { id: 14, image: trophyPic14, title: "IFL Champions 2024" },
    { id: 15, image: trophyPic15, title: "IFL Champions 2024" },
    { id: 16, image: trophyPic16, title: "IFL Champions 2024" },
    { id: 17, image: trophyPic17, title: "IFL Champions 2024" },
    { id: 18, image: trophyPic18, title: "IFL Champions 2024" },
    // { id: 19, image: littleDown, title: "LittleDown League Winners 2025" },

    // { id: 19, image: trophyPic19, title: "IFL Champions 2024" },
  ];
  const [selectedTrophy, setSelectedTrophy] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      setItemsPerPage(window.innerWidth < 768 ? 1 : 3);
    };

    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleTrophyClick = (trophy) => {
    setSelectedTrophy(trophy);
  };

  const closeModal = () => {
    setSelectedTrophy(null);
  };

  const paginatedTrophies = trophies.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleNextPage = () => {
    if (currentPage < Math.ceil(trophies.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <section className="trophies-section">
      <h2 className="section-title">Our Trophies</h2>

      {/* Trophy Cards */}
      <div className="trophy-cards">
        {paginatedTrophies.map((trophy) => (
          <div
            key={trophy.id}
            className="trophy-card"
            onClick={() => handleTrophyClick(trophy)}
          >
            <img src={trophy.image} alt={trophy.title} className="trophy-image" />
            <h3 className="trophy-title">{trophy.title}</h3>
          </div>
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button onClick={handlePreviousPage} disabled={currentPage === 1}>
          Previous
        </button>
        <button
          onClick={handleNextPage}
          disabled={currentPage === Math.ceil(trophies.length / itemsPerPage)}
        >
          Next
        </button>
      </div>

      {/* Trophy Modal */}
      {selectedTrophy && (
        <div className="trophy-modal" onClick={closeModal}>
          <div className="trophy-modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedTrophy.image}
              alt={selectedTrophy.title}
              className="trophy-modal-image"
            />
            <h3>{selectedTrophy.title}</h3>
            <button className="close-button" onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Trophie;